import React from 'react';

const DashboardListCard = ({
    titles = [], // Array of titles (1-3)
    items = [], // Array of items with multiple values
    className = '',
    titleClassName = '',
    itemClassName = '',
    showRanking = false,
    maxItems = 5,
    columnCount = 2,
    emptyMessage = 'No data available'
}) => {
    // Ensure we have at least 1 title and items have at least 2 columns
    const titleCount = Math.min(titles.length, 3);


    // Get alignment classes based on column position
    const getColumnAlignment = (columnIndex, totalColumns) => {
        if (columnIndex === 0) return 'text-left';
        if (columnIndex === totalColumns - 1) return 'text-right';
        return 'text-center';
    };

    return (
        <div className={`bg-grayBgNormal  rounded-lg p-6 shadow-sm border border-borderUnderline ${className}`}>
            {/* Titles Section */}
            <div className="mb-4">
                {titleCount === 1 ? (
                    <h3 className={`text-base font-semibold text-textSecondary ${titleClassName}`}>
                        {titles[0]}
                    </h3>
                ) : (
                                    <div className={`grid gap-4 ${titleCount === 2 ? 'grid-cols-[1fr_auto]' : 'grid-cols-[1fr_1fr_auto]'}`}>
                    {titles.slice(0, titleCount).map((title, index) => (
                        <h3 
                            key={index}
                            className={`${index === 0 ? 'text-base text-textSecondary font-semibold' : 'text-sm text-textSecondary font-medium'} self-center   ${getColumnAlignment(index, titleCount)} ${titleClassName}`}
                        >
                            {title}
                        </h3>
                    ))}
                </div>
                )}
            </div>
            
            {/* Items Section */}
            {items.length === 0 ? (
                <div className="text-textSecondary text-sm py-4 text-center">
                    {emptyMessage}
                </div>
            ) : (
                <div className="space-y-2">
                    {items.slice(0, maxItems).map((item, index) => (
                        <div
                            key={index}
                            className={`flex items-center ${itemClassName}`}
                        >
                            {/* Ranking (if enabled) */}
                            {showRanking && (
                                <span className="text-sm text-textPrimary w-6 flex-shrink-0">
                                    {index + 1}.
                                </span>
                            )}
                            
                            {/* Icon (if present) */}
                            {item.icon && (
                                <div className="mr-1 w-5 h-5  flex-shrink-0">
                                    {item.icon}
                                </div>
                            )}
                            
                            {/* Main content grid */}
                            <div className={`flex-1 grid gap-4 ${columnCount === 2 ? 'grid-cols-[1fr_4.875rem]' : 'grid-cols-[1fr_1fr_4.875rem]'}`}>
                                {/* First column - always present */}
                                <div className={`${getColumnAlignment(0, columnCount)}`}>
                                    <p className="text-sm text-textPrimary truncate">
                                        {item.title || item.name || item.label}
                                    </p>
                                
                                </div>
                                
                                {/* Second column - always present */}
                                <div className={`${getColumnAlignment(1, columnCount)}`}>
                                    <span className="text-sm text-textPrimary">
                                        {item.subtitle || item.value }
                                    </span>
                                </div>
                                
                                {/* Third column - only if 3 columns */}
                                {columnCount === 3 && (
                                    <div className={`${getColumnAlignment(2, columnCount)}`}>
                                        <span className="text-sm text-textPrimary">
                                            {item.value }
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DashboardListCard; 